module.exports = __webpack_public_path__ + "img/nature-28.8602164d.jpg";